import {animate, style, transition, trigger} from '@angular/animations';

const ANIMATION_DURATION = '.3s';

export const inOutAnimation = trigger(
  'inOut',
  [
    transition(
      ':enter',
      [
        style({height: 0, opacity: 0, 'padding-top': 0, 'margin-top': 0, 'margin-bottom': 0, overflow: 'hidden'}),
        animate(`${ANIMATION_DURATION} ease-out`,
          style({height: '*', opacity: '*', 'padding-top': '*', 'margin-top': '*', 'margin-bottom': '*'})),
      ],
    ),
    transition(
      ':leave',
      [
        style({height: '*', opacity: '*', 'padding-top': '*', overflow: 'hidden', 'margin-top': '*', 'margin-bottom': '*'}),
        animate(`${ANIMATION_DURATION} ease-in`,
          style({height: 0, opacity: 0, 'padding-top': 0, 'margin-top': 0, 'margin-bottom': 0})),
      ],
    ),
  ],
);
